<template>
  <div>
    <div class="table--wrapper" :class="{ 'overflow': overflow }">
    
      <table 
        class="table has-tiny-font my-3"
        :class="{ 'overflow': overflow, 'is-fullwidth': !overflow }">

        <thead>
          <tr class="has-text-centered is-size-6">
            <th
              v-for="(header, i) in headers"
              :key="i"
              :class="header.class">
              <div v-html="header.label"></div>
              <div v-if="header.label == 'MEASURE'">
                <span v-if="railOrWall == 'wall'">(SQFT)</span>
                <span v-else>(LF)</span>
              </div>
            </th>
          </tr>
        </thead>

        <tbody>
          <template v-for="(row, i) in taxIncentiveTotal">
            <tr
              class="v-centered has-text-right"
              :key="i">
              <td class="capitalize has-text-left">
                {{ row.ti_type }}
              </td>
              <td>
                {{ row.total_measure | commasep(0, true) }}
              </td>
              <td>
                {{ row.total_upfront_cost | commasep(0, true) }}
              </td>
              <td>
                {{ row.value_tax_incentive_gross | commasep(0, true) }}
              </td>
              <td>
                {{ row.elec_proceeds_for_business | commasep(0, true) }}
              </td>
              <td>
                {{ row.maintenance_cost | commasep(0, true) }}
              </td>
              <td>
                {{ row.net_cladding_cost_year1_gross | commasep(0, true) }}
              </td>
              <td>
                {{ row.net_cladding_cost_year30_gross | commasep(0, true) }}
              </td>
            </tr>
          </template>
        </tbody>

      </table>
    </div>

    <div class="table--wrapper" :class="{ 'overflow': overflow }">
      <table 
        class="table has-tiny-font my-3"
        :class="{ 'overflow': overflow, 'is-fullwidth': !overflow}">

        <thead>
          <tr class="has-text-centered is-size-6">
            <th
              v-for="(header, i) in headers"
              :key="i"
              :class="header.class">
              <div v-html="header.label"></div>
              <div v-if="header.label == 'MEASURE'">
                <span v-if="railOrWall == 'wall'">(SQFT)</span>
                <span v-else>(LF)</span>
              </div>
              <div
                v-if="header.label != 'CLADDING TYPE' && header.label != 'MEASURE'"
                class="unit">
                <span v-if="railOrWall == 'wall'">/SQFT</span>
                <span v-else>/LF</span>
              </div>
            </th>
          </tr>
        </thead>

        <tbody>
          <template v-for="(row, i) in taxIncentiveUnit">
            <tr
              class="v-centered has-text-right"
              :key="i">
              <td class="capitalize has-text-left">
                {{ row.ti_type }}
              </td>
              <td>
                {{ row.total_measure | commasep(0, true) }}
              </td>
              <td>
                {{ row.total_upfront_cost | commasep(2, true) }}
              </td>
              <td>
                {{ row.value_tax_incentive_gross | commasep(2, true) }}
              </td>
              <td>
                {{ row.elec_proceeds_for_business | commasep(2, true) }}
              </td>
              <td>
                {{ row.maintenance_cost | commasep(2, true) }}
              </td>
              <td>
                {{ row.net_cladding_cost_year1_gross | commasep(2, true) }}
              </td>
              <td>
                {{ row.net_cladding_cost_year30_gross | commasep(2, true) }}
              </td>
            </tr>
          </template>
        </tbody>

      </table>

      <div class="help is-italic mb-5" v-if="taxIncentiveTotal.length > 0">
        Note: The value of the tax incentive is calculated using the active solar area, 
        <strong>
          {{ mpa.measure | commasep(0) }} 
          <span v-if="railOrWall == 'wall'">SQFT</span><span v-else>LF</span>
        </strong>, 
        and the active solar cost of 
        <span v-if="hasMpaPrice">
          <strong>{{ mpa.upfront_cost | currency(0) }}</strong> under MPA 
        </span>
        <span v-if="hasDpaPrice">
          <span v-if="hasMpaPrice">and </span> 
          <strong>{{ dpa.upfront_cost | currency(0) }}</strong> under DPA
        </span>.
      </div>

      <!-- <div class="mb-5">
        The value of the savings from the tax incentives over 30 years is 
        approximately 
        <span v-if="hasMpaPrice">
          <strong>{{ mpa.value_tax_incentive | currency(0) }}</strong> under MPA
        </span> 
        <span v-if="hasDpaPrice">
          <span v-if="hasMpaPrice">and </span>
          <span>
            <strong>{{ dpa.value_tax_incentive | currency(0) }}</strong> under DPA
          </span>
        </span>.
        
      </div> -->
      
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    estimation: {
      type: Object
    },
    hasMpaPrice: {
      type: Boolean,
      default: true
    },
    hasDpaPrice: {
      type: Boolean,
      default: true
    },
    overflow: {
      type: Boolean,
      default: true
    },
    railOrWall: {
      type: String,
      default: 'wall'
    }
  },
  data() {
    return {
      headers: [
        { label: 'CLADDING TYPE' },
        { label: 'MEASURE' },
        { label: 'UPFRONT <span class="text--nowrap">COST ($)</span>' },
        { label: 'TAX <span class="text--nowrap">INCENTIVE ($)</span>' },
        { label: 'ELECTRICITY <span class="text--nowrap">PROCEED ($)</span><div class="is-size-teeny has-text-weight-normal">30 YEARS</div>' },
        { label: 'MAINTENANCE <span class="text--nowrap">COST ($)</span><div class="is-size-teeny has-text-weight-normal">30 YEARS</div>' },
        { label: 'NET <span class="text--nowrap">COST ($)</span><div class="text--nowrap is-size-teeny has-text-weight-normal">IN YEAR ONE</div>' },
        { label: 'NET <span class="text--nowrap">COST ($)</span><div class="text--nowrap is-size-teeny has-text-weight-normal">IN 30 YEARS</div>' }
      ]
    }
  },
  computed: {
    taxIncentiveMpa({ estimation }) {
      return estimation.estimation_summary.tax_incentive
    },
    taxIncentiveDpa({ estimation }) {
      return estimation.estimation_summary_dpa.tax_incentive
    },
    mpa({ taxIncentiveMpa, railOrWall }) {
      let keyword = railOrWall == 'wall' ? 'Solar Cladding' : 'Solar Railing'
      return taxIncentiveMpa.filter(d => d.aggregation == 'total' && d.ti_type.includes(keyword))[0]
    },
    dpa({ taxIncentiveDpa, railOrWall }) {
      let keyword = railOrWall == 'wall' ? 'Solar Cladding' : 'Solar Railing'
      return taxIncentiveDpa.filter(d => d.aggregation == 'total' && d.ti_type.includes(keyword))[0]
    },
    taxIncentiveTotal({ taxIncentiveMpa, taxIncentiveDpa, railOrWall, hasMpaPrice, hasDpaPrice }) {
      let res = []
      let altMat = []
      let keyword = railOrWall == 'wall' ? 'Cladding' : 'Railing'

      if (taxIncentiveMpa && hasMpaPrice) {
        res.push(
          taxIncentiveMpa.filter(
            d => d.aggregation == 'total' && d.ti_type.includes(keyword) &&
                !d.ti_type.includes('Alternative Materials')
          )[0]
        );
        altMat.push(
          taxIncentiveMpa.filter(
            d => d.aggregation == 'total' && d.ti_type.includes(keyword) &&
                d.ti_type.includes('Alternative Materials')
          )[0]
        );
      }
      if (taxIncentiveDpa && hasDpaPrice) {
        res.push(
          taxIncentiveDpa.filter(
            d => d.aggregation == 'total' && d.ti_type.includes(keyword) &&
                !d.ti_type.includes('Alternative Materials')
          )[0]
        );
        altMat.push(
          taxIncentiveMpa.filter(
            d => d.aggregation == 'total' && d.ti_type.includes(keyword) &&
                d.ti_type.includes('Alternative Materials')
          )[0]
        );
      }

      let altMatCombined = altMat.reduce((a,b) => {
        Object.keys(a).forEach(key => {
          if (!isNaN(a[key])) {
            a[key] = a[key] + b[key]
          }
        })
        return a
      }, {
        aggregation: "total",
        ti_type: "Alternative Materials",
        elec_proceeds_for_business: 0,
        maintenance_cost: 0,
        total_measure: 0,
        net_cladding_cost_year1: 0,
        net_cladding_cost_year30: 0,
        net_cladding_cost_year1_gross: 0,
        net_cladding_cost_year30_gross: 0,
        total_upfront_cost: 0,
        value_tax_incentive: 0,
        value_tax_incentive_gross: 0
      })

      res.push(altMatCombined)

      return res
    },
    taxIncentiveUnit({ taxIncentiveMpa, taxIncentiveDpa, railOrWall, hasMpaPrice, hasDpaPrice }) {
      let res = []
      let altMat = []
      let keyword = railOrWall == 'wall' ? 'Cladding' : 'Railing'

      if (taxIncentiveMpa && hasMpaPrice) {
        res.push(
          taxIncentiveMpa.filter(
            d => d.aggregation == 'unit' && d.ti_type.includes(keyword) &&
                !d.ti_type.includes('Alternative Materials')
          )[0]
        );
        altMat.push(
          taxIncentiveMpa.filter(
            d => d.aggregation == 'unit' && d.ti_type.includes(keyword) &&
                d.ti_type.includes('Alternative Materials')
          )[0]
        );
      }
      if (taxIncentiveDpa && hasDpaPrice) {
        res.push(
          taxIncentiveDpa.filter(
            d => d.aggregation == 'unit' && d.ti_type.includes(keyword) &&
                !d.ti_type.includes('Alternative Materials')
          )[0]
        );
        altMat.push(
          taxIncentiveMpa.filter(
            d => d.aggregation == 'unit' && d.ti_type.includes(keyword) &&
                d.ti_type.includes('Alternative Materials')
          )[0]
        );
      }

      let altMatCombined = altMat.reduce((a,b) => {
        Object.keys(a).forEach(key => {
          if (!isNaN(a[key])) {
            a[key] = a[key] + b[key]
          }
        })

        return a
      }, {
        aggregation: "unit",
        ti_type: "Alternative Materials",
        elec_proceeds_for_business: 0,
        maintenance_cost: 0,
        total_measure: 0,
        net_cladding_cost_year1: 0,
        net_cladding_cost_year30: 0,
        net_cladding_cost_year1_gross: 0,
        net_cladding_cost_year30_gross: 0,
        total_upfront_cost: 0,
        value_tax_incentive: 0,
        value_tax_incentive_gross: 0
      })

      res.push(altMatCombined)

      return res
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/flexbox.scss';
@import '@/styles/table.scss';

$overflow-margin: -35px;

.table--wrapper {
  position: relative;
  &.overflow {
    left: $overflow-margin;
  }
}

.table {
  left: 0px;
  top: 0px;
  page-break-inside: avoid;

  tbody tr td {
    page-break-inside: avoid !important;
  }

  &.overflow {
    width: calc(
      var(--pagedjs-width) -
      var(--pagedjs-margin-right) -
      var(--pagedjs-margin-left) + 70px
    );
    th {
      font-size: 0.65em !important;

      .is-size-teeny {
        font-size: 0.6em !important;
      }

      .text--nowrap {
        white-space: nowrap;
      }
    }

    td {
      font-size: 0.7em !important;
    }
  }

  th {
    color: #fff;
    background: #0E4E74;
    font-size: 0.7em;

    .unit {
      color: #F16635;
    }

    .is-size-teeny {
      font-size: 0.6em !important;
    }
  }

  td:first-child {
    color: #0E4E74;
    background: #E6ECF2;
    font-size: 0.65em;
    font-weight: bold;
  }
}

.capitalize {
  text-transform: capitalize;
}

.uppercase {
  text-transform: uppercase;
}
</style>
